'use client'

import { useState } from 'react'

import { Pagination } from '@/components/atoms/pagination'
import { RegulationCard } from '@/components/molecules/cards/regulation-card'
import Container from '@/components/templates/container/container'

import { RegulationListHeader } from './header'

interface RegulationListProps {
  data: Regulation
  categoryList: string[]
}

export const RegulationList = ({ data, categoryList }: RegulationListProps) => {
  const [activePage, setActivePage] = useState(0)
  const [selectedCategory, setSelectedCategory] = useState('')
  const [size, setSize] = useState(5)

  const startIndex = activePage * size
  let filteredRegulations = data.items

  if (selectedCategory && selectedCategory !== 'Semua Peraturan') {
    filteredRegulations = data.items.filter((regulation) => regulation.fields.category === selectedCategory)
  }

  const visibleRegulations = filteredRegulations.slice(startIndex, startIndex + size).sort((a, b) => {
    return new Date(b.sys.updatedAt).getTime() - new Date(a.sys.updatedAt).getTime()
  })

  const totalPage = Math.ceil(filteredRegulations.length / size)

  return (
    <section className="relative w-full py-9 lg:py-16 bg-slate-50">
      <Container className="space-y-6">
        <RegulationListHeader
          categoryList={categoryList}
          setCategory={setSelectedCategory}
          setSize={(value: string) => setSize(parseInt(value, 10))}
        />

        <article className="flex flex-col gap-3">
          {visibleRegulations.length > 0 ? (
            visibleRegulations.map((item, index) => (
              <RegulationCard
                key={index}
                title={item.fields.title}
                category={item.fields.category}
                link={item.fields.link}
              />
            ))
          ) : (
            <p>Peraturan tidak ditemukan...</p>
          )}
        </article>

        <div className="flex justify-center">
          <Pagination totalPage={totalPage} activeIndex={activePage} onChange={setActivePage} />
        </div>
      </Container>
    </section>
  )
}
